import React, { Component } from 'react';
import { LeaderboardContext } from '../context';

import styled from '@emotion/styled';

// eslint-disable-next-line import/default
import apiWorker from 'workerize-loader!../api';
import SortedCarousel from '../components/sorted_carousel';

class ConnectedCarouselSorted extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entries: {
        fetching: false,
        fetched: false,
        data: [],
      },

      leaderboard: {
        fetching: false,
        fetched: props.leaderboard ? true : false,
        errors: [],
        data: { ...props.leaderboard.data, promoPages: [] },
      },

      questions: {
        fetching: false,
        fetched: false,
        data: [],
      },
    };

    this.worker = new apiWorker();

    this.worker.setBaseUrl(`//api.${props.domain}/events/${props.eventId}`);
    this.worker.setHeaders({
      Accept: 'application/vnd.api+json',
      Authorization: `Bearer ${props.accessToken}`,
    });
  }

  async _leaderboardFetch() {
    return await this.worker.fetchLeaderboard();
  }

  async _entriesFetch() {
    return await this.worker.fetchEntries();
  }

  async _questionsFetch() {
    return await this.worker.fetchQuestions();
  }

  async _fetchNewData() {
    const allFetches = Promise.all([
      this._leaderboardFetch(),
      this._entriesFetch(),
      this._questionsFetch(),
    ]);

    const [leaderboardRes, userEntriesRes, questionsRes] = await allFetches;

    this.setState(state => ({
      connectedOnce: true,
      leaderboard: {
        ...state.leaderboard,
        fetching: false,
        fetched: true,
        data: {
          ...state.leaderboard.data,
          promoPages: leaderboardRes,
        },
      },
      entries: {
        ...state.entries,
        fetching: false,
        fetched: true,
        data: userEntriesRes,
      },
      questions: {
        ...state.questions,
        fetching: false,
        fetched: true,
        data: questionsRes.questions,
      },
    }));
  }

  componentDidMount() {
    this._fetchNewData();
  }

  render() {
    const { leaderboard, entries, questions } = this.state;
    const { Loading } = ConnectedCarouselSorted;

    if (leaderboard.fetched && entries.fetched && questions.fetched) {
      return (
        <LeaderboardContext.Provider value={this.state.leaderboard.data}>
          <SortedCarousel
            animationEndedCallback={() => this._fetchNewData()}
            promoPages={leaderboard.data.promoPages}
            userEntries={entries.data}
            questions={questions.data}
            promoPageTimer={leaderboard.data.attributes.promo_page_timer}
            entriesPageTimer={leaderboard.data.attributes.entries_page_timer}
            resultsPageTimer={leaderboard.data.attributes.results_page_timer}
          />
        </LeaderboardContext.Provider>
      );
    } else {
      return <Loading>Loading</Loading>;
    }
  }
}

ConnectedCarouselSorted.Loading = styled.h1`
  color: ${props => props.theme.backgroundTextColor};
`;

export default ConnectedCarouselSorted;
